// Dashboard 360

import React from "react";

// Mui
import Grid from "@mui/material/Grid2";
import useMediaQuery from "@mui/material/useMediaQuery";

// Custom
import Layout from "../../layout";
import EnergyOverview from "../../components/dashboardCards/EnergyOverview";
import QuickAccess from "../../components/dashboardCards/QuickAccess";
import DashboardMap from "../../components/dashboardCards/DashboardMap";

// Theme
import theme from "../../theme";
import { Card, Divider } from "@mui/material";

const Dashboard360: React.FC = () => {
  const matches = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Layout>
      <Grid container>
        <Grid size={{ xs: 12, md: 12, lg: 12 }}>
          <DashboardMap />
        </Grid>
      </Grid>

      <Card className="dashboard_360">
        <Grid container spacing={matches ? 1 : 2.25}>
          <Grid
            size={{ xs: 12, md: 9.35, lg: 9.35 }}
            sx={{ borderRight: "1px solid #E6E8EC" }}>
            <EnergyOverview />
          </Grid>
          {/* <Divider orientation="vertical" flexItem /> */}
          <Grid size={{ xs: 12, md: 2.65, lg: 2.65 }}>
            <QuickAccess />
          </Grid>
        </Grid>
      </Card>

      {/* <Grid
        container
        mt="18px"
        spacing={matches ? 1 : 2.25}
        alignItems="stretch" // keep both same height
      >
        <Grid size={{ xs: 12, md: 9.35, lg: 9.35 }}>
          <EnergyOverview />
        </Grid>

        <Grid
          size={{ xs: 12, md: 2.65, lg: 2.65 }}
          sx={{
            display: { xs: "none", md: "flex" }, // hide divider on mobile
            alignItems: "stretch",
          }}>
          <Divider orientation="vertical" flexItem />
        </Grid>

        <Grid size={{ xs: 12, md: 2.65, lg: 2.65 }}>
          <QuickAccess />
        </Grid>
      </Grid> */}
    </Layout>
  );
};

export default Dashboard360;
